var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import CommonService from '../../../api/CommonService';
var CopyDialog = (function (_super) {
    __extends(CopyDialog, _super);
    function CopyDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.treeData = [];
        _this.dataValue = '';
        _this.copyItems = [
            {
                name: '供应商货品关系',
                id: 1
            },
            {
                name: '供应商货品价格',
                id: 2
            }
        ];
        _this.formData = {};
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now();
            }
        };
        return _this;
    }
    CopyDialog.prototype.setEtPickerOptions = function (formData) {
        var eTime = new Date(formData.es_time);
        eTime.setHours(0, 0, 0, 0);
        return {
            disabledDate: function (time) {
                if (!formData.es_time) {
                    return time.getTime() < Date.now();
                }
                return time.getTime() < eTime;
            }
        };
    };
    CopyDialog.prototype.created = function () {
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        this.supplier = this.supplier;
        this.getTreeCategoryData();
    };
    CopyDialog.prototype.mounted = function () {
    };
    CopyDialog.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.service.getSupplierupperCategoryList().then(function (res) {
            res.data.data.map(function (item) {
                if (item.category_id || item.category_name) {
                    item.supplier_upper_id = item.category_id + 'category_id';
                    item.supplier_upper_name = item.category_name;
                }
                if (item.children && item.children.length > 0) {
                    item.children.map(function (child, index) {
                        child.parent_id = item.category_id;
                        child.parent_name = item.category_name;
                    });
                }
            });
            _this.treeData = res.data.data;
        });
    };
    CopyDialog.prototype.close = function () {
        this.$closeDialog();
    };
    CopyDialog.prototype.confirm = function () {
        if (!this.formData.supplier_upper_ids || this.formData.supplier_upper_ids && !this.formData.supplier_upper_ids.length)
            return this.$message.error('请选择需要复制到的供应商');
        if (!this.formData.copy_type || this.formData.copy_type && !this.formData.copy_type.length)
            return this.$message.error('请选择复制项');
        this.$closeDialog();
        var copyType;
        if (!!this.formData.copy_type && this.formData.copy_type.length > 0) {
            if (this.formData.copy_type.length == 2) {
                copyType = 3;
            }
            else {
                copyType = this.formData.copy_type[0];
            }
        }
        else {
            copyType = '';
        }
        var params = {
            supplier_upper_id: this.supplier.supplier_upper_id,
            supplier_upper_ids: (this.formData.supplier_upper_ids || []).join(','),
            copy_type: copyType
        };
        if ((this.formData.copy_type || []).indexOf(2) > -1) {
            params = Object.assign({}, params, {
                es_time: this.formData.es_time,
                ee_time: this.formData.ee_time
            });
        }
        this.$emit('copyConfig:ok', params);
    };
    CopyDialog.prototype.normalizer = function (node) {
        return {
            id: node.supplier_upper_id,
            label: node.supplier_upper_name,
            children: node.children,
        };
    };
    CopyDialog = __decorate([
        Component
    ], CopyDialog);
    return CopyDialog;
}(VueDialog));
export default CopyDialog;
